import React, { Fragment } from 'react';
import RegistryOfficeAccordion from '../shared/accordion-person';
import ChangeControlDataAccordion from '../shared/accordion-change-control-data';
import DeathDataAccordion from '../shared/accordion-death-data';
import JudgmentDataAccordion from '../shared/accordion-judgment-data';

interface CancellationNonResidentContentProps {
  disabled?: boolean;
}

const CancellationNonResidentContent: React.FC<CancellationNonResidentContentProps> = ({
  disabled,
}: CancellationNonResidentContentProps) => {
  const [expandedRegistry, setExpandedRegistry] = React.useState<boolean>(false);
  const [expandedControl, setExpandedControl] = React.useState<boolean>(false);
  const [expandedDeath, setExpandedDeath] = React.useState<boolean>(false);
  const [expandedJudgment, setExpandedJudgment] = React.useState<boolean>(false);

  return (
    <Fragment>
      <RegistryOfficeAccordion
        expanded={expandedRegistry}
        toggle={() => setExpandedRegistry(!expandedRegistry)}
      />
      <ChangeControlDataAccordion
        expanded={expandedControl}
        toggle={() => setExpandedControl(!expandedControl)}
      />
      <DeathDataAccordion
        expanded={expandedDeath}
        toggle={() => setExpandedDeath(!expandedDeath)}
        disabled={disabled}
      />
      <JudgmentDataAccordion
        expanded={expandedJudgment}
        toggle={() => setExpandedJudgment(!expandedJudgment)}
        disabled={disabled}
      />
    </Fragment>
  );
};

CancellationNonResidentContent.displayName = 'CancellationNonResidentContent';
export default CancellationNonResidentContent;
